export default "__VITE_ASSET__BP480xqG__"